export default __webpack_public_path__ + "static/media/typing-bubble-icon-light.d671cde1.svg";